/**
 * Small shared color helpers.
 */

/**
 * Lighten a hex color toward white by `percent` (0..1).
 * @param {string} hex - e.g. '#FBC02D' (with or without '#').
 * @param {number} percent - 0 = unchanged, 1 = white.
 * @returns {string} hex string; returns the input unchanged if it can't be parsed.
 */
export function lightenHex(hex, percent) {
  const num = parseInt(String(hex).replace('#', ''), 16);
  if (Number.isNaN(num)) return hex;
  const r = Math.min(255, Math.floor((num >> 16) + (255 - (num >> 16)) * percent));
  const g = Math.min(255, Math.floor(((num >> 8) & 0x00ff) + (255 - ((num >> 8) & 0x00ff)) * percent));
  const b = Math.min(255, Math.floor((num & 0x0000ff) + (255 - (num & 0x0000ff)) * percent));
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}
